import { useEffect, useRef, useState } from "react";
import { ApiError, TERMINAL, type Api, type Job } from "./api";

/** Polls one job until it reaches a terminal state; `onFinished` runs once then (coins may have been refunded). */
export function useJob(api: Api, jobId: string | null, pollMs: number, onFinished: (job: Job) => void) {
  const [job, setJob] = useState<Job | null>(null);
  const [error, setError] = useState<string | null>(null);
  const finished = useRef(onFinished);
  finished.current = onFinished;

  useEffect(() => {
    setJob((current) => (current && current.id === jobId ? current : null)); // keep the job POST /api/jobs returned
    setError(null);
    if (!jobId) return;
    let stop = false;
    let timer: number | undefined;
    const tick = async () => {
      try {
        const next = await api.job(jobId);
        if (stop) return;
        setJob(next);
        setError(null);
        if (TERMINAL.includes(next.status)) {
          finished.current(next);
          return;
        }
      } catch (e) {
        if (stop) return;
        setError(e instanceof ApiError ? e.code : "network");
      }
      timer = window.setTimeout(tick, pollMs);
    };
    void tick();
    return () => {
      stop = true;
      window.clearTimeout(timer);
    };
  }, [api, jobId, pollMs]);

  return { job, setJob, error };
}
